

















/* eslint-disable no-console */
import Vue from 'vue'
import { Component, Watch } from 'vue-property-decorator'
import OpenSeadragon from "@/components/OpenSeadragon.vue";
import ImageSelector from "@/components/ImageSelector.vue";
import {SimpleImageDTO} from "@/dtos/sqe-dtos";

@Component({
  components: {
    OpenSeadragon,
    ImageSelector
  }
})
export default class ImageViewer extends Vue {
  imageURLs: string[] = []
  selectedURL = 0
  tileSource = ''
  rotate = 0
  side = "recto"
  type = "color"
  images: SimpleImageDTO[] = []

  typeSelect(t: string) {
    this.type = t;
    this.getTileSource();
  }

  sideSelect(t: string) {
    this.side = t;
    this.getTileSource();
  }

  async getTileSource() {
    this.tileSource = '';
    let selectedImg = this.images.filter(
            x => x.type == this.type && x.side == this.side
    );
    if (selectedImg.length > 0) {
      //this.tileSource = selectedImg[0].url + "/info.json"
      const res = await this.$http.get(selectedImg[0].url + "/info.json");
      let editedRes = res.data;
      URL.revokeObjectURL(this.tileSource);
      this.tileSource = URL.createObjectURL(
              new Blob([JSON.stringify(editedRes)], { type: "application/json" })
      );
    }
  }

  @Watch("$store.state.image_catalog_id")
  async imageCatalogueIdChanged(newValue: string, oldValue: string) {
    if (oldValue !== newValue && newValue !== undefined) {
      try {
        const images = await this.$com.sqeComms?.getV1ImagedObjectsImagedObjectId(newValue);
        if (images !== undefined) {
          this.images = images.images;
          await this.getTileSource();
        }
        // const res = await this.$http.post(`${this.$apiurl}v1/image-get`, {"sqe_session_id": this.$store.state.session_id, "image_catalog_id": newValue})
        // this.imageURLs = res.data.listing
        // res.data.listing.map((v, idx) => {if (v.type === 1) this.selectedURL = idx})
        // this.getTileSource()
      } catch (err) {
        console.error(err);
      }
    }
  }

  @Watch("$store.state.imageSide")
  imageSideChanged(newValue: string, oldValue: string) {
    if (oldValue !== newValue && newValue !== undefined) {
      this.sideSelect(newValue)
    }
  }

  @Watch('selectedURL')
  selectedURLChanged(newValue: number, oldValue: number) {
    if (newValue !== oldValue) {
      this.getTileSource();
    }
  }
}
